import { render, staticRenderFns } from "./guessYouLike.vue?vue&type=template&id=02a3e544&scoped=true&"
import script from "./guessYouLike.vue?vue&type=script&lang=js&"
export * from "./guessYouLike.vue?vue&type=script&lang=js&"
import style0 from "./guessYouLike.vue?vue&type=style&index=0&id=02a3e544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a3e544",
  null
  
)

component.options.__file = "guessYouLike.vue"
export default component.exports